import { graphQLClient } from "./clients/graphqlClient";
import { manuallySyncExpertMutation } from "./graphql/mutations/manualSyncMutation";

const manuallySyncExpert = async (id: string) => {
  await graphQLClient.request(
    manuallySyncExpertMutation,
    { expertId: id }
  );
}

const ExpertsService = {
  manuallySyncExpert,
};

export default ExpertsService;